import React, { useEffect } from 'react';
import { useTheme } from 'styled-components';
import { Close } from "../../assets/Close";
import { useWindowSize } from "../../hooks/useWindowSize";
import { Container, Content, Header, ContainerTitle, ContainerButton, Description, Body, Title, Button, Wrapper } from "./Modal.styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * A simple modal component
 *
 * @param title Title of the modal
 * @param maxWidth Max width of the modal
 * @param maxHeight Max height of the modal
 * @param description Description of the modal
 * @param isOpen If the modal is open
 * @param children Children of the modal
 * @param onClose Function to be called when the modal is closed
 * */
const Modal = props => {
  const {
    title,
    maxWidth = 500,
    maxHeight = 300,
    description,
    isOpen,
    children,
    onClose
  } = props;
  useEffect(() => {
    const handleKeyUp = event => {
      if (event.key === 'Escape') {
        onClose?.();
      }
    };
    window.addEventListener('keyup', handleKeyUp);
    return () => {
      window.removeEventListener('keyup', handleKeyUp);
    };
  }, [onClose]);
  const theme = useTheme();
  const windowSize = useWindowSize();
  return /*#__PURE__*/_jsx(Container, {
    onClick: onClose,
    open: isOpen,
    screenWidth: windowSize.width ?? 500,
    children: /*#__PURE__*/_jsxs(Content, {
      maxWidth: maxWidth,
      maxHeight: maxHeight,
      screenWidth: windowSize.width ?? 500,
      onClick: e => e.stopPropagation(),
      open: isOpen,
      children: [/*#__PURE__*/_jsxs(Header, {
        screenWidth: windowSize.width ?? 500,
        children: [/*#__PURE__*/_jsxs(ContainerTitle, {
          screenWidth: windowSize.width ?? 500,
          children: [/*#__PURE__*/_jsx(Title, {
            screenWidth: windowSize.width ?? 500,
            children: title
          }), description && /*#__PURE__*/_jsx(Description, {
            screenWidth: windowSize.width ?? 500,
            children: description
          })]
        }), /*#__PURE__*/_jsx(ContainerButton, {
          children: /*#__PURE__*/_jsx(Button, {
            onClick: onClose,
            children: /*#__PURE__*/_jsx(Close, {
              size: "md",
              color: theme.colors.secondaryL3
            })
          })
        })]
      }), /*#__PURE__*/_jsx(Wrapper, {
        children: /*#__PURE__*/_jsx(Body, {
          screenWidth: windowSize.width ?? 500,
          children: children
        })
      })]
    })
  });
};
export { Modal };